<template>
 
  <v-app id="item">
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-snackbar v-model="snackbar" :timeout="4000" top color="red">
      <span>Incorrect Login Details</span> 
      <v-btn text color="white" @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="100%" persistent>
        <v-row justify-center align="center" justify="center">
            <v-col cols="12" sm="8" md="5">
                <v-card class="pa-7" id="login">
                    
                    <p class="white--text text-center">Your session has expired. Re-Login</p>
                    <v-card-text>
                        <v-form>
                            <v-text-field color="#08911B" solo flat label="Username"  prepend-inner-icon="mdi-account" name="username" v-model="this.$store.state.community.logindetails.consultant_id" type="text" readonly>

                            </v-text-field>
                            <v-text-field class="mt-7" solo flat label="Password" name="password" v-model="password"
                             :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            :type="show1 ? 'text' : 'password'"
                            @click:append="show1 = !show1"
                             prepend-inner-icon="mdi-lock"
                             color="#08911B"
                              >
                            </v-text-field>
                            
                         <v-card-text class="text-right">
                          <v-btn text class="white--text mt-n9 forgot" @click="dialog=false" router-link to="/">Login Another Account?</v-btn>
                        </v-card-text>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <div class="mx-auto">
                        <v-btn width="150" large color="#FFFFFF"  :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" style="color:#62AE32" v-on:click="login()">
                            Login
                        <v-icon right>mdi-login</v-icon>
                        </v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-dialog>
    <v-dialog v-model="dialogServer" overlay-color="black" width="700px" class="mt-12">
      <v-card width="685px" class=""> 
        <v-row style="background-color:white" >
          <v-col cols="12" sm="12" md="6">        
            <v-img src="/serverdown.png"></v-img>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="mx-auto">
            <v-container fluid class="fill-height">
              <v-row justify-center align="center" justify="center">
              <v-card-text class="font-weight-black">THE SERVER IS TEMPORARILY DOWN!!!<br>TRY AGAIN LATER</v-card-text>
            </v-row>
            
            </v-container>
          </v-col>
        </v-row>
        <v-card-text class="text-right">
        <v-btn dark color="rgba(98, 174, 50, 0.7)" @click="dialogServer=false">TRY AGAIN</v-btn>
      </v-card-text>
        
      </v-card>
      
    </v-dialog>
    <v-dialog v-model="dialogOffline" overlay-color="black" max-width="50%" >
        <v-row style="background-color:white" class="pa-3">
          <v-col cols="12" sm="12" md="6">        
            <v-img src="/serverdown.png"></v-img>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="mx-auto">
            <v-container fluid class="fill-height">
              <v-row justify-center align="center" justify="center">
              <v-card-text class="font-weight-black">You are currently offline
                . Please check your internet connection
              </v-card-text>
            </v-row>
            </v-container>
          </v-col>
        </v-row>
    </v-dialog>
  </v-app>
</template>

<script> 
import axios from 'axios'
import Chart from 'chart.js';
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    
    password:'',
    dialog:false,
    dialogServer:false,
    dialogOffline:false,
    snackbar:false
  }),
  methods:{
    login(){
        this.loading = true
        this.$store.dispatch("Login", {
        "username": this.$store.state.community.logindetails.consultant_id,
        "password": this.password
        })
        .then((success)=>{
          console.log(success);
          this.loading = false
          this.dialog=false; 
        })
        .catch((error)=>{
          console.log(error);
          this.loading = false
          this.snackbar = true;
        });
      }
  },
  created: function () {
    axios.interceptors.response.use(null, error => {
      if (error.response.status === 401) {
      // this.$router.push('/')
        this.dialog=true
      }else if(error.response.status === 500){
        this.dialogServer=true
      }

      return Promise.reject(error);
    });
    window.addEventListener('offline', function(e) { console.log('offline'); this.dialogOffline=true });

    window.addEventListener('online', function(e) { console.log('online'); });
  
  }
};
</script>
<style>
  *{
    font-family: 'Lato';
  }
  #item{
    background-color:#F0FFEA !important;
    min-height:100vh;
    font-family: 'Lato';
  }
  #home{
      background: url('/mainBackground.png');
      background-size: cover;
      width: 100%;
      height: 100%;
    }
    #login{
      background: rgba(98, 174, 50, 0.7);
      border-radius: 5px;
    }
    .forgot{
      text-transform: lowercase;
    }
    /* Notification style */
    .mail-table {
      max-width: 1000px;
      margin: auto;
      border-collapse: collapse;
    }
    .mail-table tr.read {
      background-color: #EEE;
    }
    .mail-table tr {
      height: 40px;
    }
    .mail-table td {
      border-bottom: 1px solid black;
      padding: 5px;
      text-align: left;
    }
    .mail-table tr:first-of-type td {
      border-top: 1px solid black;
    }
    .mail-table td p {
      max-height: 1.2em;
      overflow-y: hidden;
      margin: 0;
    }
    .mail-table td.date {
      width: 120px;
    }
    
    .hi tr.read {
      /* background-color: #EEE; */
      color: grey
    }
    .hi tr.unread {
      color: black;
      font-weight: bold;
    }
</style>